// extracted by mini-css-extract-plugin
export default {"favProductContainer":"FavCard_favProductContainer__tY8wQ"};